import React, { memo, SVGProps } from 'react'

export const Comment = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M21.3302 17.7694L20.3991 15.7426C21.1201 14.5946 21.4992 13.3091 21.4992 11.9995C21.5002 7.58921 17.2384 4 11.9996 4C6.7608 4 2.5 7.58921 2.5 11.9995C2.5 16.4098 6.76177 19.999 11.9996 19.999C13.7641 19.999 15.4719 19.5933 16.9638 18.8231L19.2335 19.8327C19.4865 19.9452 19.7444 20 19.9926 20C20.3971 20 20.7762 19.8539 21.0634 19.5702C21.5285 19.1126 21.6301 18.4222 21.3292 17.7684L21.3302 17.7694ZM20.0288 18.5501C20.019 18.5559 19.9555 18.5712 19.8373 18.5184L16.8925 17.2079L16.5672 17.3925C15.2208 18.154 13.642 18.5568 11.9996 18.5568C7.56977 18.5568 3.96553 15.6147 3.96553 11.9995C3.96553 8.38435 7.56977 5.44222 11.9996 5.44222C16.4294 5.44222 20.0336 8.38435 20.0336 11.9995C20.0336 13.1466 19.6634 14.2763 18.9638 15.2666L18.7264 15.6022L19.9946 18.3626C20.0483 18.4789 20.0336 18.5424 20.0288 18.5501Z"
      fill="currentColor"
    />
  </svg>
))
